import { Anchor, Button, Flex, Paper, Stack, Text, Title } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { useState } from "react";
import { isMobileDevice } from "../../utils/useDeviceDetection";

const ErrorComponent = () => {
  const queryClient = useQueryClient();
  const router = useRouter();
  const [numReloads, setNumReloads] = useState(0);
  const isMobile = isMobileDevice();

  const handleHardReload = async () => {
    queryClient.clear(); // Removes all queries from cache
    await queryClient.refetchQueries(); // Refetch all active queries
    router.invalidate();
  };

  const reloadApp = async () => {
    try {
      if (numReloads > 2) {
        window.location.reload(); // Prevent infinite soft reload loops
        return;
      }
      await handleHardReload();
      setNumReloads((prev) => prev + 1);
      // We can't do anything with the error here as the page is in a broken state
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      window.location.reload(); // Fallback to true hard reload if something goes wrong
    }
  };

  return (
    <Flex justify={"center"} pt={"xl"}>
      <Stack p={"lg"} maw={"770px"} w={"100%"}>
        <Paper
          my={isMobile ? "1rem" : "4rem"}
          mx={isMobile ? 0 : "3rem"}
          p={isMobile ? "1rem" : "2rem"}
          radius={"24px"}
        >
          <Flex direction="column" w={"100%"}>
            <Title>Hoppsan, något gick fel...</Title>
            <Text>
              Vänligen ladda om sidan eller kontakta oss på{" "}
              <Anchor
                href="mailto:kundtjanst@samblapension.se"
                mb={"lg"}
                mt={"lg"}
                c="var(--wallet-color-primary-700)"
              >
                <u>kundtjanst@samblapension.se</u>
              </Anchor>{" "}
              ifall felet kvarstår.
            </Text>
            <Button my={"lg"} onClick={reloadApp}>
              Ladda om sidan
            </Button>
          </Flex>
        </Paper>
      </Stack>
    </Flex>
  );
};

export default ErrorComponent;
